import FetchClient from 'ha/helpers/FetchClient';
import createMakeCall from 'ha/services/apiV2/createMakeCall';
import getBillingInformation from './getBillingInformation';
import updateBillingInformation from './updateBillingInformation';
import validateBillingInformation from './validateBillingInformation';
import updatePayoutMethodRouting from './updatePayoutMethodRouting';
import getAllPayoutMethodRouting from './getAllPayoutMethodRouting';
import getPayoutMethodRouting from './getPayoutMethodRouting';

const createMoneta = (fetchClient: FetchClient) => {
  const makeCall = createMakeCall(fetchClient);

  return {
    getBillingInformation: getBillingInformation(makeCall),
    updateBillingInformation: updateBillingInformation(makeCall),
    validateBillingInformation: validateBillingInformation(makeCall),
    updatePayoutMethodRouting: updatePayoutMethodRouting(makeCall),
    getAllPayoutMethodRouting: getAllPayoutMethodRouting(makeCall),
    getPayoutMethodRouting: getPayoutMethodRouting(makeCall),
  };
};

export default createMoneta;
